module.exports = __webpack_public_path__ + "static/media/box4.3a80fabf.jpg";